module.exports = __webpack_public_path__ + "static/media/6.26220dd4.png";